export class Authentication {
  constructor(public token: string = null,
              public refresh: string = null) {}
}
